import type { GuestPortalContextProps } from '../../../modules/context/guestPortalContextV2';
import type { GuestsRequest, MewsReservation } from '../../../modules/interfaces';

/**
 * Static sample data for the theme editor's live preview. The preview mounts the REAL guest
 * components (Header, cards) against this mocked `GuestPortalContext` value so admins see an
 * accurate render without any network calls. Only the handful of fields those components read
 * are populated; partials are cast since the components deep-optional-chain everything.
 */

const noop = () => {};

const sampleReservation = {
  Property: { bannerUrl: '' },
  Customer: { FirstName: 'Alex', LastName: 'Morgan' },
  Room: { name: 'Garden Suite', roomNumber: '204' },
  Resource: {
    ResourceName: 'Garden Suite',
    Data: { Value: { FloorOrdinalNumber: '2nd Floor' } },
  },
  StartUtc: new Date().toISOString(),
} as unknown as MewsReservation;

const samplePreregisteredGuest = {
  guest: { firstName: 'Alex', lastName: 'Morgan' },
} as unknown as GuestsRequest;

/** Build a mocked GuestPortalContext value for the preview. */
export const buildPreviewContext = (): GuestPortalContextProps => ({
  reservation: sampleReservation,
  getMewsReservations: noop,
  loadingReservation: false,
  loading: false,
  error: null,
  preregisteredGuest: samplePreregisteredGuest,
  getGuestPreregistered: noop,
  guestName: 'Alex Morgan',
  setGuestName: noop,
  addPackageToGuest: noop,
  loadingAddPackage: false,
  addPackageError: null,
  cardInfoLoading: false,
  getCardInfo: noop,
  getGuest: noop,
  dynamicQuestionsData: [],
  reservationRating: 0,
  loadingReservationRating: false,
  stripePromise: Promise.resolve(null),
});
